import React from "react";

export default React.createContext({
  isPrinting: false,
  placeholderData: {},
  placeholderKeys: [],
  isPreviewing: false
});
